var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getWebsiteUrl } from "../utils/domainUtil";
export var AuthEndpoint;
(function (AuthEndpoint) {
    AuthEndpoint["SIGN_IN"] = "signIn";
    AuthEndpoint["SIGN_OUT"] = "signOut";
    AuthEndpoint["REFRESH_TOKEN"] = "refreshToken";
})(AuthEndpoint || (AuthEndpoint = {}));
export const addParamAndEndpointToBuildFullAuthURL = (endpoint) => __awaiter(void 0, void 0, void 0, function* () {
    const applicationURL = yield getWebsiteUrl();
    const urlWithPath = new URL(`${applicationURL}/${endpoint}`);
    urlWithPath.searchParams.append("redirect_uri", applicationURL);
    return urlWithPath.toString();
});
export const getSignInURL = () => __awaiter(void 0, void 0, void 0, function* () {
    return yield addParamAndEndpointToBuildFullAuthURL(AuthEndpoint.SIGN_IN);
});
export const signOut = () => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const signOutURL = yield addParamAndEndpointToBuildFullAuthURL(AuthEndpoint.SIGN_OUT);
        const signOutResponse = yield fetch(signOutURL, {
            credentials: "same-origin",
        });
        return signOutResponse;
    }
    catch (err) {
        throw Error("Error refreshing token");
    }
});
export const refreshToken = () => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const refreshTokenURL = yield addParamAndEndpointToBuildFullAuthURL(AuthEndpoint.REFRESH_TOKEN);
        const refreshTokenResponse = yield fetch(refreshTokenURL, { method: "POST" });
        return refreshTokenResponse;
    }
    catch (err) {
        throw Error("Error refreshing token");
    }
});
